<template>
  <div class="portfolio">
    <div>
      <div class="for-dropdown-ui month">
        <div class="for-dropdown" @click="hoverDropdown" :class="{ hover: dropdownSw }">
          {{ dataEnListIndex }}
          <img class="arrow-drop" src="@/assets/images/icons/arrow_drop.svg" />
          <div class="dropdown-list">
            <div class="dropdown-list-inner">
              <ul class="class-list">
                <li
                  v-for="(item, index) in dataEnList"
                  :key="index"
                  @click="monthChange(item)"
                  :class="{ active: dataEnListIndex === item }"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="for-dropdown-bg" v-if="dropdownSw" @click="dropdownSw = false"></div>
      </div>

      <div class="for-dropdown-ui year">
        <div class="for-dropdown" @click="hoverDropdown1" :class="{ hover: dropdownSw1 }">
          {{ dataEnListYearIndex }}
          <img class="arrow-drop" src="@/assets/images/icons/arrow_drop.svg" />
          <div class="dropdown-list">
            <div class="dropdown-list-inner">
              <ul class="class-list">
                <li
                  v-for="(item, index) in dataEnListYear"
                  :key="index"
                  @click="yearChange(item)"
                  :class="{ active: dataEnListYearIndex === item }"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="for-dropdown-bg" v-if="dropdownSw1" @click="dropdownSw1 = false"></div>
      </div>
    </div>
    <div
      class="journal-list-box-inner"
      v-infinite-scroll="loadMore"
      v-if="list.length > 0"
      v-loading="loading"
    >
      <div class="journal-box" v-for="(item, index) in list" :key="index">
        <div
          class="journal-img"
          @click="toPreview(item)"
          :style="'background-image:url(' + item.photos + ');'"
        ></div>
        <div class="journal-text">
          <div class="journal-tit" :title="item.title">{{ item.title }}</div>
          <div class="journal-stu">
            <head-img
              :src="studentInfo.photo ? `${studentInfo.photo}` : ``"
              :firstName="studentInfo.firstName"
              :lastName="studentInfo.lastName"
              line-height="16"
            />
            <span class="stu-name">{{ studentInfo.firstName }} {{ studentInfo.lastName }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-box" slot="empty" v-else>
      <img :src="require('@/assets/images/moments/empty_photo.png')" />
      <p>No portfolio yet.</p>
    </div>
  </div>
</template>

<script>
import { Ajax } from '@/common'
import { listState } from '@/common/nav-state'

export default {
  name: 'PortfolioView',
  props: {
    studentInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // Define any data properties needed for the component
      list: [],
      loading: false,
      pageNum: 1,
      pages: 0,
      dropdownSw: false,
      dropdownSw1: false,
      dataEnListIndex: 'All',
      dataEnListYearIndex: 'All',
      monthArr: {
        All: '',
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      },
      dataEnListYear: ['All'],
      dataEnList: [
        'All',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    }
  },
  watch: {
    studentInfo: {
      handler(newVal) {
        console.log('studentInfo changed', newVal)
        if (newVal && newVal.id) {
          this.setYears()
          // 身份落地（含 A→B 复用）：统一在身份 watcher 播种+取数，避免与 $route watcher 一次导航两次请求
          this._syncListFromRoute(true)
        }
      },
      immediate: true
    },
    '$route.query': {
      deep: true,
      handler() {
        // 身份切换进行中（URL 已换人、studentInfo 未落地）：归口 studentInfo watcher，防止拿旧身份取数
        const routeId = String((this.$route.query && this.$route.query.id) || '')
        const propId = this.studentInfo && this.studentInfo.id ? String(this.studentInfo.id) : ''
        if (routeId && propId && routeId !== propId) return
        this._syncListFromRoute(false)
      }
    }
  },
  created() {
    // Fetch initial data or perform setup tasks
    // this.getList();
  },
  methods: {
    monthChange(val) {
      this.dataEnListIndex = val
      this.pageNum = 1 // Reset page number on month change
      this._pushList({ month: val })
      this.getList()
    },
    yearChange(val) {
      this.dataEnListYearIndex = val
      this.pageNum = 1 // Reset page number on year change
      this._pushList({ year: val })
      this.getList()
    },
    // 列表 URL 状态的可比对键：Month/Year 下拉（'All' 是控件自身哨兵，R19；无限滚动 pageNum 豁免 R23 不进 URL）
    _stateKeys() {
      return ['month', 'year']
    },
    // 缺失/null 键折叠为 ''，保证 push 产生的“删键”与读取侧可比
    _normalizeNavState(map) {
      const out = {}
      this._stateKeys().forEach((key) => {
        const v = map[key]
        out[key] = v === undefined || v === null ? '' : String(v)
      })
      return out
    },
    // b 缺失（studentInfo immediate watcher 先于 created 落地 _navState）视为“有变化”
    _sameNavState(a, b) {
      if (!b) return false
      return this._stateKeys().every((key) => a[key] === b[key])
    },
    // 自身导航统一入口：push 后记录本页最近一次 URL 状态，供 $route 监听识别自身导航
    _pushList(patch) {
      const query = listState.push(this.$router, this.$route, patch)
      this._navState = this._normalizeNavState(query)
    },
    // 以 URL 状态重建下拉选中（垃圾值回退 'All'，不流入请求体）
    _seedFromQuery(state) {
      this.dataEnListIndex = this.dataEnList.includes(state.month) ? state.month : 'All'
      this.dataEnListYearIndex = this.dataEnListYear.includes(state.year) ? state.year : 'All'
    },
    // 身份与列表态共用同一重同步入口：身份落地/前进后退复用只落地一次取数。
    // force：studentInfo prop 更新沿用旧口径必取一次；pageNum 仅在列表语义变化时回 1（身份+prop 刷值不重置，同旧口径）
    _syncListFromRoute(force) {
      const identity = this.studentInfo && this.studentInfo.id ? String(this.studentInfo.id) : ''
      if (!identity) return
      // 缺失键在 _navState 空间归一 ''（与 _pushList 投影同口径，自身 push 才能跳过）；'All' 映射归口 _seedFromQuery
      const state = listState.read(this.$route, this._stateKeys())
      const navState = this._normalizeNavState(state)
      const stateChanged = !this._sameNavState(navState, this._navState)
      const identityChanged = identity !== this._navIdentity
      if (!force && !stateChanged && !identityChanged) return
      this._navState = navState
      this._navIdentity = identity
      this._seedFromQuery(state)
      if (stateChanged || identityChanged) this.pageNum = 1
      this.getList()
    },
    setYears() {
      let startYear = this.studentInfo.year || '2022' // Adjust as needed
      let currentYear = new Date().getFullYear()
      this.dataEnListYear = ['All']
      for (let year = startYear; year <= currentYear; year++) {
        this.dataEnListYear.push(year.toString())
      }
    },
    loadMore() {
      if (this.pageNum < this.pages && !this.loading) {
        this.getList(true)
      }
    },
    // Define any methods needed for the component
    async getList(s) {
      this.pageNum = s ? this.pageNum + 1 : this.pageNum
      this.loading = true
      var res = await Ajax.post('/attendance/timeLine/getFeedByStudentV2', {
        current: this.pageNum,
        size: 20,
        type: 4,
        year: this.dataEnListYearIndex === 'All' ? '' : this.dataEnListYearIndex,
        month: this.dataEnListIndex === 'All' ? '' : this.monthArr[this.dataEnListIndex],
        studentId: this.studentInfo.id
      })
      this.loading = false
      if (res.code == '0000') {
        if (s) {
          this.list = [...this.list, ...res.data.records]
        } else {
          this.list = res.data.records
        }
        this.pages = res.data.pages
        console.log('this.list', this.list)
      }
    },
    toPreview(item) {
      let url = this.$router.resolve({
        path: `/journal/view`,
        query: { id: item.id, type: 'portfolio' }
      })
      let win = window.open(url.href, '_blank')
      win.onload = function () {
        setTimeout(function () {
          win.document.title = 'Preview'
        }, 100)
      }
    },
    hoverDropdown1() {
      this.dropdownSw1 = !this.dropdownSw1
    },
    hoverDropdown() {
      this.dropdownSw = !this.dropdownSw
    }
  }
}
</script>

<style lang="less" scoped>
.portfolio {
}
.empty-box {
  position: fixed;
  left: 50%;
  top: 50%;
  margin: -125px 0 0 -107px;
  width: 214px;
  height: 250px;
  text-align: center;
  img {
    width: 100%;
    display: block;
  }

  p {
    margin-top: 20px;
    font-size: 20px;
    font-family: Roboto;
    color: #606367;
  }
}
.for-dropdown-ui {
  display: inline-block;
  margin: 20px 10px 0 0;
  width: 120px;
  height: 36px;

  .for-dropdown-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    overflow: hidden;
  }

  .for-dropdown {
    position: relative;
    z-index: 100;
    padding: 0 16px;
    height: 36px;
    line-height: 36px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    color: #202124;
    cursor: pointer;

    &.hover {
      .dropdown-list {
        display: block;
      }
    }

    .arrow-drop {
      position: absolute;
      right: 4px;
      top: 7px;
      width: 20px;
      height: 20px;
    }

    .dropdown-list {
      display: none;
      position: absolute;
      left: 0;
      top: 35px;
      padding: 0 2px 0 0;
      width: 119px;
      background: #fff;
      box-shadow: 0px 3px 3px #0000004d;
      border-radius: 4px;

      .dropdown-list-inner {
        padding: 8px 0;
        max-height: 176px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        .select-all {
          padding-left: 16px;
          line-height: 28px;
          font-size: 14px;
          color: #202124;

          .el-checkbox {
            width: 100%;
            color: #202124;
          }

          &:hover {
            background-color: #eee;
          }
        }

        .class-list {
          padding: 0;

          li {
            padding-left: 16px;
            line-height: 32px;
            font-size: 14px;
            font-family: Roboto;

            .el-checkbox {
              width: 100%;
            }

            &.active,
            &:hover {
              background-color: #eee;
            }
          }
        }
      }
    }
  }
}

.journal-list-box-inner {
  position: relative;
  overflow: hidden;
  padding: 20px 0 112px 0;
  margin-bottom: 92px;
  margin-right: -46px;

  .journal-box {
    float: left;
    position: relative;
    margin: 0 24px 24px 0;
    width: 328px;
    // height: 200px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;

    .journal-col {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }

    .journal-text {
      padding: 0 20px;
      height: 92px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .journal-tit {
        width: 256px;
        // line-height: 64px;
        font-size: 16px;
        text-align: left;
        font-family: Roboto;
        color: #202124;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .journal-stu {
        display: flex;
        align-items: center;
        height: 24px;
        border-radius: 16px;
        border: 1px solid #e0e0e0;
        background-color: #fff;
        padding: 0 10px 0 4px;
        width: fit-content;
        margin-top: 8px;
        .stu-name {
          font-family: Roboto;
          font-size: 12px;
          color: #202124;
          margin-left: 8px;
        }
      }
    }

    .journal-img {
      display: block;
      width: 100%;
      height: 136px;
      border-radius: 8px 8px 0 0;
      background-size: cover;
      background-position: top;
      cursor: pointer;
    }
  }
}
</style>
